export { getGlobalAttributes, type GlobalAttributesT } from './getGlobalAttributes.js';
export { useGetGlobalAttributes } from './useGetGlobalAttributes.js';
export { globalAttributesPropTypes } from './globalAttributesPropTypes.js';
